import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import router from './router'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import Vuex from 'vuex'
import VeeValidate, { Validator } from 'vee-validate'
import ptBR from 'vee-validate/dist/locale/pt_BR'
import store from './store/store'
import AirbnbStyleDatepicker from 'vue-airbnb-style-datepicker'
import 'vue-airbnb-style-datepicker/dist/vue-airbnb-style-datepicker.min.css'
import BlockUI from 'vue-blockui'
import VueTheMask from 'vue-the-mask'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
import money from 'v-money'
import VueGoogleCharts from 'vue-google-charts'

export const broadcastServer = new Vue()

let isToday = require('date-fns/is_today')
isToday(new Date())

export const operacao = {
  ADICIONAR: 'adicionar',
  ALTERAR: 'alterar'
}
export const modo = {
  LISTA: 'lista',
  EDICAO: 'edicao'
}
export const cor = {'background-color': `#${localStorage.getItem('corApp')}`}
export const corSelec = {'background-color': `#${localStorage.getItem('corSelecionado')}`}

const datepickerOptions = {
  sundayFirst: false,
  dateLabelFormat: 'dddd, MMMM D, YYYY',
  days: ['Segunda', 'Terça', 'Quarta', 'Quinta', 'Sexta', 'Sabado', 'Domingo'],
  daysShort: ['Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab', 'Dom'],
  monthNames: [
    'Janeiro',
    'Fevereiro',
    'Março',
    'Abril',
    'Maio',
    'Junho',
    'Julho',
    'Agosto',
    'Setembro',
    'Outubro',
    'Novembro',
    'Dezembro'
  ],
  keyboardShortcuts: [
    {symbol: '↵', label: 'Seleciona a data', symbolDescription: 'Pressionar enter'},
    {symbol: '←/→', label: 'Move para trás (esquerda) e frente (direita) um dia de cada vez.', symbolDescription: 'Left or right arrow keys'},
    {symbol: '↑/↓', label: 'Move para trás (cima) e frente (baixo) uma semana de cada vez.', symbolDescription: 'Up or down arrow keys'},
    {symbol: 'PgUp/PgDn', label: 'Troca os meses.', symbolDescription: 'PageUp and PageDown keys'},
    {symbol: 'Home/End', label: 'Vai para o primeiro dia da semana.', symbolDescription: 'Teclas Home ou End'},
    {symbol: 'Esc', label: 'Fecha este painel', symbolDescription: 'Escape key'},
    {symbol: '?', label: 'Abre este painel', symbolDescription: 'Question mark'}
  ],
  colors: {
    selected: '#484848',
    inRange: '#b0b0b0',
    selectedText: '#fff',
    text: '#565a5c',
    inRangeBorder: '#f6f6f6',
    disabled: '#fff'
  },
  texts: {
    apply: 'Aplicar',
    cancel: 'Cancelar',
    keyboardShortcuts: 'Teclas de Atalho'
  }
}

Vue.use(VueGoogleCharts)
Vue.use(VueAwesomeSwiper, /* { default global options } */)
Vue.use(money, {precision: 4})
Vue.use(AirbnbStyleDatepicker, datepickerOptions)
Vue.use(BlockUI)
Validator.localize({ pt_BR: ptBR })
Vue.use(VeeValidate, { locale: 'pt_BR', fieldsBagName: 'veeFields' })
Vue.use(Vuex)
Vue.use(BootstrapVue)
Vue.use(VueTheMask)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})
// tablePedidos.listarPedidos(objectPost).then(response => {
//
// }).catch(error => {
//   console.log(error)
//   alert('Aconteceu alguma coisa!' + error)
// }).finally(() => {
//   this.blockUiVisibility = false
// })



// WEBPACK FOOTER //
// ./src/main.js